import PropTypes from 'prop-types';
import React from 'react';

import EditableDatePicker from '../forms/editableDatePicker.jsx';

class LayoutDatePicker extends React.Component {
  static defaultProps = {
    condition: true,
    label: '',
  };

  static propTypes = {
    condition: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    dataKey: PropTypes.string.isRequired,
    dateFormat: PropTypes.string.isRequired,
    editMode: PropTypes.bool.isRequired,
    label: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.object,
    group: PropTypes.object,
    validate: PropTypes.func,
    validateMessage: PropTypes.string,
    didValidate: PropTypes.func,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    required: PropTypes.bool,
  };

  render() {
    const {condition, title, label, ...props} = this.props;

    if (condition) {
      return <div className='form-group' title={title}>
        <label>{label}</label>
        <EditableDatePicker {...props} />
      </div>;
    }
    return null;
  }
}

export default LayoutDatePicker;
